import angular from 'angular';
import moment from "moment";

(function() {
    'use strict';
    angular.module('app.core').factory('BillingAddress', BillingAddress);

    BillingAddress.$inject = ['$translate'];

    function BillingAddress() {
        BillingAddress.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getPdpReDate: getPdpReDate,
            buildPdpRe: buildPdpRe
        };

        function BillingAddress(billingAddressCodeData) {
            if (!billingAddressCodeData) {
                this.buildEmpty();
            } else {
                this.build(billingAddressCodeData);
            }
        }

        return BillingAddress;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.address = null;
            this.description = null;
            this.pdpRe = {
                startDate: null,
                endDate: null,
                sentToPpf: false,
            };
        }

        function build(billingAddress) {
            this.id = billingAddress.id || null;
            this.address = billingAddress.address || null;
            this.description = billingAddress.description || null;
            this.creationDate = moment(billingAddress.creationDate).startOf('day') || null;
            this.buildPdpRe(this,billingAddress);
        }


        function getPdpReDate(dateType){
            return `${this.pdpRe && this.pdpRe[dateType] ? this.pdpRe[dateType].format('DD/MM/YYYY') : '-'} `
        }

        function buildPdpRe(currentObj, billingAddress){
            if(billingAddress.pdpRe != null){
                currentObj.pdpRe = {
                    startDate : billingAddress.pdpRe.startDate ? moment(billingAddress.pdpRe.startDate).startOf('day') : null,
                    endDate : billingAddress.pdpRe.endDate ? moment(billingAddress.pdpRe.endDate).startOf('day') : null,
                    sentToPpf : billingAddress.pdpRe.sentToPpf || false
                };
            }
        }
    }
})();
